/**
 * Communities domain routes
 */
export const routes = {
  communityGroups: {
    root: '/community-groups',
    detail: (groupId: string) => `/community-groups/${groupId}`,
  },
  communities: {
    root: '/communities',
    detail: (communityId: string) => `/communities/${communityId}`,
    classificationTesting: {
      root: (communityId: string) => `/communities/${communityId}/classification-testing`,
      withPrompt: (communityId: string, promptVersion: string) => `/communities/${communityId}/classification-testing?promptVersion=${promptVersion}`,
    },
    contentSearch: {
      root: (communityId: string) => `/communities/${communityId}/content-search`,
    },
  },
};
